<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khoảng ngày' }}
                </div>
                <div class="">
                  <CalendarRange v-model="date" mode="date" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Mã voucher' }}
                </div>
                <div class="">
                  <input type="text" placeholder="selectwithsearch" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Tên voucher' }}
                </div>
                <div class="">
                  <input type="text" placeholder="selectwithsearch" />
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Người thao tác' }}
                </div>
                <div class="">
                  <input type="text" placeholder="selectwithsearch" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container" style="display: flex">
            <div class="das-form-title">
              <span class="main-title">
                {{ `Báo cáo sử dụng voucher` }}
              </span>
            </div>

            <DownloadBtn @openNoteDialog="dialogNoteVisible = true" />
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
            />
          </div>
        </div>
      </div>
    </div>

    <NoteDialog v-model="dialogNoteVisible">
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>- Mã voucher: Hiển thị mã voucher được sử dụng</li>
            <li>- Tên voucher: hiển thị tên voucher được sử dụng</li>
            <li>
              - Thời gian áp dụng: Hiển thị thời gian áp dụng của voucher dưới
              dạng Từ ngày - Đến ngày: Format: DDMMYYYY- DDMMYYYY
            </li>
            <li>- Mã đặt phòng: Hiển thị mã đặt phòng áp dụng voucher</li>
            <li>
              - Doanh thu: Hiển thị Doanh thu tổng bao gồm phòng + dịch vụ + ăn
              (không tính vé)
            </li>
            <li>- Giảm giá: Số tiềngiảm khi sử dụng voucher</li>
            <li>- Thành tiền: Doanh thu - Giảm giá</li>
            <li>
              - Người thao tác: hiển thị họ và tên người sử dụng voucher cho
              khách
            </li>
            <li>- Tổng: Hiển thị tổng của các cột thông tin về tiền</li>
          </ul>
        </div>
      </div>
    </NoteDialog>
  </div>
</template>

<script>
import DownloadBtn from '../components/DownloadBtn.vue'
import NoteDialog from '../components/NoteDialog.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'

export default {
  components: { DownloadBtn, NoteDialog, CalendarRange },
  data() {
    return {
      // date
      date: {
        start: null,
        end: null
      },

      // grid
      columns: [
        { headerName: 'Mã voucher', field: '' },
        { headerName: 'Tên voucher', field: '' },
        { headerName: 'Thời gian áp dụng', field: '' },
        { headerName: 'Thời gian sử dụng', field: '' },
        { headerName: 'Mã đặt phòng', field: '' },
        { headerName: 'Doanh thu', field: '' },
        { headerName: 'Giảm giá', field: '' },
        { headerName: 'Thành tiền', field: '' },
        { headerName: 'Người thao tác', field: '' }
      ],
      rows: [],

      // dialog
      dialogNoteVisible: false
    }
  },
  methods: {
    onSearch() {},
    onResetSearch() {}
  }
}
</script>
